module.exports = {"crossSell":{"componentName":"CrossSell"},"cross_sell_widget":{"componentName":"CrossSellWidget"}}